module.exports = __webpack_public_path__ + "img/bookingSuccess.69c719f6.png";